import { render, staticRenderFns } from "./UserAssignment.vue?vue&type=template&id=3cfda989&scoped=true"
import script from "./UserAssignment.vue?vue&type=script&lang=js"
export * from "./UserAssignment.vue?vue&type=script&lang=js"
import style0 from "./UserAssignment.vue?vue&type=style&index=0&id=3cfda989&prod&scoped=true&lang=css"
import style1 from "./UserAssignment.vue?vue&type=style&index=1&id=3cfda989&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfda989",
  null
  
)

export default component.exports